import getAuthSession from './auth';
import axios from 'axios';
import { AssessorProfile, AssessorReportingCompany } from '../interfaces/users.interface';

/**
 * Saves ONLY the fields in `patch`. Callers must never send a whole cached profile:
 * a grid row's copy goes stale as soon as another of its cells saves, and a full-object
 * PATCH writes those stale values back over the newer ones (TPE-2955).
 */
export async function updateAssessorProfile(id: number, patch: Partial<AssessorProfile>) {
  const authSession = await getAuthSession();
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_API}/assessor-profiles/${id}/`,
    patch,
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as AssessorProfile;
}

export async function createAssessorProfile(companyId: number, data: Partial<AssessorProfile>) {
  const authSession = await getAuthSession();
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_API}/assessor-profiles/`,
    { company: companyId, ...data },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as AssessorProfile;
}

export async function createAssessorReportingCompany(name: string) {
  const authSession = await getAuthSession();
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_API}/assessor-reporting-companies/`,
    { name },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as AssessorReportingCompany;
}

export const fetchAssessorReportingCompanies = async () => {
  const authSession = await getAuthSession();
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_API}/assessor-reporting-companies/`,
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data.results as AssessorReportingCompany[];
};